<script lang="ts">
	import { devices } from '../../../stores';
	import BaseConditionNode from './BaseConditionNode.svelte';
	import { resolveDeviceInStore } from '../helpers/resolveDeviceInStore';
	import type { NodeData } from '../types/flow-types';

	export let id: string;
	export let data: NodeData;
	export let selected: boolean = false;
	export let validated: boolean = true;
	export let errors: string[] = [];

	$: channel = parseInt(String(data.channel ?? '0'), 10) || 0;
	$: device = data.deviceId
		? resolveDeviceInStore($devices, String(data.deviceId), channel)
		: undefined;
	$: deviceName = String(data.deviceName || device?.name || 'Choose a device');
	$: property = String(data.property || '')
		.replace(/[_-]+/g, ' ')
		.trim();
	$: lower = data.lowerThreshold ?? '?';
	$: upper = data.upperThreshold ?? '?';
	$: unit = String(data.propertyUnit || '');
	$: configured = Boolean(data.deviceId && property && Number(lower) < Number(upper));
	$: title = configured ? `${deviceName} · ${property}` : 'Configure hysteresis';
</script>

<BaseConditionNode
	{id}
	type="hysteresisCondition"
	{data}
	{selected}
	validated={validated && configured}
	{errors}
	cardTitle={title}
	nodeTypeLabel="Hysteresis condition"
	{...$$restProps}
>
	<div class="thresholds">
		<div class="threshold active"><i class="fa-solid fa-arrow-up"></i> ON above {upper}{unit}</div>
		<div class="deadband">Hold state between {lower}{unit} and {upper}{unit}</div>
		<div class="threshold inactive">
			<i class="fa-solid fa-arrow-down"></i> OFF below {lower}{unit}
		</div>
	</div>
</BaseConditionNode>

<style>
	.thresholds {
		display: flex;
		min-width: 14rem;
		flex-direction: column;
		gap: 0.3rem;
		font-size: 0.75rem;
	}
	.threshold {
		display: flex;
		align-items: center;
		gap: 0.35rem;
		border-radius: 0.4rem;
		padding: 0.3rem 0.5rem;
		font-weight: 650;
	}
	.active {
		background: color-mix(in srgb, #22c55e 12%, transparent);
		color: #16a34a;
	}
	.inactive {
		background: color-mix(in srgb, #ef4444 10%, transparent);
		color: #dc2626;
	}
	.deadband {
		padding: 0 0.5rem;
		color: var(--flow-slot-muted);
		font-size: 0.68rem;
	}
</style>
